/**
 *  create by tnanc
 */
import types from '../mutation-types'
const state = {
  resourcePermissionList: [],
  companyInfo: {
    id: 0,
    mobile: '',
    clientId: '',
    clientSecret: '',
    companyName: '',
    businessContact: '',
    contactNumber: '',
    companyAddress: '',
    companyWebsiteAddress: '',
    businessLicenseNumber: '',
    businessLicenseUrl: ''
  },
  devdefaultvx: ''
}

const getters = {
  resourcePermissionList: state => state.resourcePermissionList,
  companyInfo: state => state.companyInfo,
  devdefaultvx: state => state.devdefaultvx
}

const actions = {
}

const mutations = {
  [types.RESOURCE_PERMISSION_LIST] (state, resourcePermissionList) {
    let nowStr = new Date().Format('yyyy-MM-dd')
    if (resourcePermissionList) {
      for (let item of resourcePermissionList) {
        item.name = item.resource.name
        if (item.enabled) {
          switch (item.status) {
            case 0 : item.resourceStatus = '未开通'; break
              // 试用
            case 1 : if (nowStr < item.expireDate) {
              item.resourceStatus = '试用中'
            } else {
              item.resourceStatus = '试用结束'
            }
              break
              // 服务中
            case 2 : if (nowStr < item.expireDate) {
              item.resourceStatus = '服务中'
            } else {
              item.resourceStatus = '服务到期'
            }
              break
          }
        } else {
          item.resourceStatus = '已禁用'
        }
      }
      state.resourcePermissionList = resourcePermissionList
    } else {
      state.resourcePermissionList = []
    }
  },
  // 记录公司信息
  [types.COMPANY_INFO] (state, companyInfo) {
    state.companyInfo = companyInfo
    delete state.companyInfo.resourcePermissionList
    // delete state.companyInfo.registerTime
  },
  [types.DEVDEFAULTVX] (state, pagedefault) {
    state.devdefaultvx = pagedefault
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/develop.js